// === Pomocné funkce ===

// 1️⃣ Vytvoření QR do canvasu bez <img>
function renderQrCanvasFromHash(qrHash, qrSize = 240, colorDark = '#000000', colorLight = '#ffffff') {
    const tmp = document.createElement('div');
    const qr = new QRCode(tmp, {
        text: qrHash,
        width: qrSize,
        height: qrSize,
        colorDark,
        colorLight,
        correctLevel: QRCode.CorrectLevel.H
    });

    const qrobj = qr._oQRCode;
    const count = qrobj.getModuleCount();

    const canvas = document.createElement('canvas');
    canvas.width = qrSize;
    canvas.height = qrSize;
    const ctx = canvas.getContext('2d', { alpha: false });
    ctx.imageSmoothingEnabled = false;

    ctx.fillStyle = colorLight;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const cell = qrSize / count;
    ctx.fillStyle = colorDark;

    for (let r = 0; r < count; r++) {
        for (let c = 0; c < count; c++) {
            if (qrobj.isDark(r, c)) {
                const x = Math.round(c * cell);
                const y = Math.round(r * cell);
                const w = Math.ceil((c + 1) * cell) - x;
                const h = Math.ceil((r + 1) * cell) - y;
                ctx.fillRect(x, y, w, h);
            }
        }
    }

    tmp.remove();
    return canvas;
}

// 2️⃣ Spojí QR + texty
function composeQrPoster(qrCanvas, opts) {
    const { userName = '', label = '', padding = 30, textHeight = 60, bg = '#ffffff', textColor = '#000000', font = '16px Arial' } = opts || {};

    const out = document.createElement('canvas');
    out.width = qrCanvas.width + padding * 2;
    out.height = qrCanvas.height + padding * 2 + textHeight;

    const ctx = out.getContext('2d', { alpha: false });
    ctx.imageSmoothingEnabled = false;

    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, out.width, out.height);

    ctx.drawImage(qrCanvas, padding, padding);

    ctx.fillStyle = textColor;
    ctx.textAlign = 'center';
    ctx.font = font;

    const baseY = padding + qrCanvas.height;
    if (userName) ctx.fillText(userName, out.width / 2, baseY + 25);
    if (label)    ctx.fillText(label, out.width / 2, baseY + 50);

    return out;
}

// 3️⃣ Spolehlivé stažení PNG (funguje i na Androidu)
function downloadCanvasPng(canvas, fileName = 'qr-vydej-jidel.png') {
    canvas.toBlob(function (blob) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => { URL.revokeObjectURL(url); a.remove(); }, 0);
    }, 'image/png');
}


// === Hlavní logika ===

function showQrCodeModal(qrHash) {
    const $modal = $('#qr-modal');
    const container = document.getElementById('qr-code-container');

    $modal.data('qr-hash', qrHash);

    container.innerHTML = '';
    new QRCode(container, {
        text: qrHash,
        width: 240,
        height: 240,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
    });

    $modal.show();
}

// Karta do Wallet: která tlačítka ukázat podle zařízení. iPhone/iPad/Mac → Apple Wallet,
// Android → Google Wallet, jiný počítač → obě + rada otevřít odkaz v telefonu (.pkpass
// na Windows nic neotevře, Google odkaz se dá dokončit přihlášením na telefonu).
function setupWalletButtons() {
    const $wallet = $('#qr-wallet');
    if (!$wallet.length) return;

    const ua = navigator.userAgent || '';
    // iPad se hlásí jako Macintosh — pro nás je to jedno, obojí je Apple Wallet
    const isApple = /iPhone|iPad|iPod|Macintosh/.test(ua);
    const isAndroid = /Android/.test(ua);

    if (isApple) {
        $wallet.find('[data-platform="google"]').hide();
    } else if (isAndroid) {
        $wallet.find('[data-platform="apple"]').hide();
    } else {
        $wallet.find('.qr-wallet__hint--desktop').prop('hidden', false);
    }
    // když platforma nemá nakonfigurovanou svou peněženku, nezůstane prázdný blok
    // (modal je v tuhle chvíli zavřený, proto se nekouká na :visible, ale na to, co jsme sami schovali)
    const remaining = $wallet.find('[data-platform]').filter(function () { return this.style.display !== 'none'; });
    if (!remaining.length) {
        $wallet.hide();
    }

    // Po kliknutí ukázat, co bude dál — Apple ani Google nás po uložení karty nevrátí zpět,
    // takže jediná chvíle, kdy jde strávníkovi něco říct, je teď.
    $wallet.on('click', '.qr-wallet__button', function () {
        $wallet.find('.qr-wallet__hint').prop('hidden', true);
        $wallet.find('.qr-wallet__added').prop('hidden', false);
    });
}

$(document).ready(function() {
    setupWalletButtons();

    // zavření modalu
    $('.qr-close').on('click', function() {
        $('#qr-modal').hide();
    });

    // klik mimo modal
    $(window).on('click', function(event) {
        if (event.target.id === 'qr-modal') {
            $('#qr-modal').hide();
        }
    });

    // 📥 Stáhnout
    $('#qr-download').on('click', function(e) {
        e.preventDefault();

        const $modal = $('#qr-modal');
        const qrHash = $modal.data('qr-hash');
        if (!qrHash) return;

        const userName = $(this).data('name') || '';
        const label = $(this).data('label') || '';

        const qrCanvas = renderQrCanvasFromHash(qrHash, 240, '#000000', '#ffffff');
        const finalCanvas = composeQrPoster(qrCanvas, { userName, label });

        downloadCanvasPng(finalCanvas, 'qr-vydej-jidel.png');
    });

    // 🖨️ Tisk – bez záhlaví/zápatí, nahoře na stránce
    $('#qr-print').on('click', function(e) {
        e.preventDefault();

        const $modal = $('#qr-modal');
        const qrHash = $modal.data('qr-hash');
        if (!qrHash) return;

        const userName = $(this).data('name')  || '';
        const label    = $(this).data('label') || '';

        const qrCanvas    = renderQrCanvasFromHash(qrHash, 240, '#000000', '#ffffff');
        const finalCanvas = composeQrPoster(qrCanvas, { userName, label });

        const naturalW = finalCanvas.width;
        const naturalH = finalCanvas.height;

        finalCanvas.toBlob(function(blob) {
            const url = URL.createObjectURL(blob);
            const w = window.open('', '_blank');
            w.document.write(`
      <html>
        <head>
          <title>${label}</title>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <style>
            /* Vypnutí záhlaví a zápatí – Chrome/Edge respektují margin:0 */
            @page {
              size: A4 portrait;
              margin: 0;
            }

            html, body {
              margin: 0;
              padding: 0;
              background: #fff;
            }

            body {
              text-align: center;
              padding-top: 20mm; /* mírný odstup od horního okraje */
            }

            img {
              width: ${naturalW}px;
              height: auto;
              image-rendering: pixelated;
              image-rendering: crisp-edges;
              -ms-interpolation-mode: nearest-neighbor;
              page-break-inside: avoid;
              break-inside: avoid;
              max-width: 100%;
            }

            @media print {
              html, body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              /* Není jistota, ale některé prohlížeče respektují toto */
              header, footer { display: none !important; }
            }
          </style>
        </head>
        <body>
          <img src="${url}" alt="QR" width="${naturalW}" height="${naturalH}">
          <script>
            window.onload = function() {
              const img = document.querySelector('img');
              if (img && !img.complete) {
                img.onload = () => setTimeout(()=>window.print(), 100);
              } else {
                setTimeout(()=>window.print(), 100);
              }
            };
          <\/script>
        </body>
      </html>
    `);
            w.document.close();
        }, 'image/png');
    });



});
